import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import ExpandableHtml from "../../user_content/expandable_html";
import ChoicePollVoteNewsfeedItem from "./choice_poll_vote_newsfeed_item";

const TAKE_THE_POLL_LABEL = "Take the Poll";

export default GrComponentFactory.createClass({
  displayName: "PollVoteNewsfeedItem",

  propTypes: {
    resource: GrPropTypes.pollVoteNewsfeedResource(),
  },

  getPollNameHtml(){
    return { __html: this.props.resource.pollName };
  },

  renderBody() {
    const imageProps = {
      altText: TAKE_THE_POLL_LABEL,
      url: this.props.resource.imageUrl,
      linkUrl: this.props.resource.isGroupPoll ?
        this.props.resource.groupUrl : this.props.resource.url,
    };
    return (
      <SocialUpdateBody image={imageProps}>
        <div className="gr-newsfeedItem__pollName" dangerouslySetInnerHTML={this.getPollNameHtml()} />
        { this.renderPollVote() }
        { this.props.resource.isGroupPoll ? this.renderGroupName() : null }
      </SocialUpdateBody>
    );
  },

  renderPollVote() {
    return <div className="gr-newsfeedItem__pollDetails">
      <span className="gr-newsfeedItem__pollLabel">Vote:</span>
      <ExpandableHtml className="gr-newsfeedItem__pollAnswer"
                      {...this.props.resource.answer} />
    </div>;
  },

  renderGroupName() {
    return <div className="gr-newsfeedItem__pollDetails">
      <span className="gr-newsfeedItem__pollLabel">Group Poll by</span>
      <a href={this.props.resource.groupUrl}>{ this.props.resource.groupName } </a>
    </div>;
  },

  renderPollLinks() {
    return [<a href={this.props.resource.url}>{TAKE_THE_POLL_LABEL}</a>];
  },

  render() {
    if (this.props.resource.isChoicePoll) {
      return <ChoicePollVoteNewsfeedItem {...this.props} />;
    } else {
      return <SocialUpdate
        header={<span>voted on a poll</span>}
        body={this.renderBody()}
        additionalFooterLinks={this.renderPollLinks()}
        {...this.props} />;
    }
  },
});
